import { LINKS_REGEX } from '../../../../../../../../../utils/constants';

export const filterIconLinks = (
  links: DiagramAddIconFormFieldsDatum[],
): DiagramAddIconFormFieldsDatum[] =>
  links.filter((link) => new RegExp(LINKS_REGEX).test(link.value || ''));
